import Marionette from 'backbone.marionette'; // TODO Shouldn't need this - it's because we're using `Marionette.getOption`
import {
  CompositeView, ItemView, locale, util
} from '@glu/core';
import dialog from '@glu/dialog';
import template from './advancedSearch.hbs';

export default CompositeView.extend({
  template,
  itemView: ItemView.extend({
    template: () => ''
  }),
  className: 'advanced-search',
  modalClass: 'modal-lg advanced-search-modal',
  itemViewContainer: '.search-control-list',
  totalFilters: 0,
  dialogTitle: '',
  dialogButtons: [],
  ui: {
    addFilterContainer: '.add-filter-container',
    applyAdvanced: 'input[data-hook="apply-advanced"]',
    addFilter: 'button[data-control="addFilter"]'
  },
  events: {
    submit: 'handleSubmit',
    'click @ui.applyAdvanced': 'handleSubmit',
    'click @ui.addFilter': 'handleAddFilter'
  },
  constructor: function (opts) {
    CompositeView.prototype.constructor.call(this, opts);
    this.SearchViewClass = opts.filterViewClass;
  },
  initialize() {
    this.dialogTitle = locale.get('manageFilters');
    this.dialogButtons = [{
      text: locale.get('apply'),
      className: 'btn btn-primary',
      callback: 'handleSubmit'
    }, {
      text: locale.get('cancel'),
      className: 'btn btn-tertiary',
      callback: 'cancel'
    }];
    // get the total number of filter items by removing the un-'filterable' ones
    const options = this.options.columns || this.columns;
    const filterOptions = util.filter(options.models, (model) => (model.get('filterable') !== false));
    this.totalFilters = filterOptions.length;
  },

  cancel() {
    dialog.close();
  },
  onRender() {
    this.delegateEvents();
    this.handleAlreadyAddedFilters();
    this.addFirstFilter();
    this.showHideAddFilterButton();
  },

  addFirstFilter() {
    if (this.collection.isEmpty()) {
      this.addFilter(); // output the first filter selection
    }
  },

  handleAlreadyAddedFilters() {
    this.closeChildren();

    this.collection.each(model => {
      if (!model.get('field')) {
        return;
      }
      this.addFilter(model);
    });
  },

  showHideAddFilterButton() {
    const filtersLength = this.children.length;
    if (filtersLength >= this.totalFilters) {
      this.ui.addFilter.hide();
    }
    this.ui.addFilter.show();
  },

  addFilter(model) {
    const filtersLength = this.children.length;
    if (filtersLength >= this.totalFilters) {
      return;
    }
    const optionsCollections = this.options.columns || this.columns;
    const grid = this.options.grid || this.grid;

    const view = new this.SearchViewClass({
      filtersCollection: this.collection,
      collection: optionsCollections,
      first: this.children.length === 0,
      grid,
      model,
      filterProc: this.options.filterProc,
      advancedSearch: true
    });

    view.render();
    this.listenTo(view, {
      'filter:remove': this.removeFilter,
      filter: this.handleAddFilter
    });

    this.ui.addFilterContainer.append(view.el);

    this.children.add(view);
  },

  handleAddFilter(e) {
    this.addFilter();
    this.trigger('add', this, e);

    this.showHideAddFilterButton();
  },

  handleSubmit(e) {
    e.preventDefault();
    this.collection.reset(this.getFilters());
    this.trigger('submit', this, e);
    dialog.close();
  },

  itemViewOptions() {
    return {
      collection: Marionette.getOption(this, 'columns')
    };
  },

  getFilters() {
    // remove empty children
    const filters = this.children.map((child) => {
      if (child.$el.html().length > 0) {
        if (child.createFilter) {
          return child.createFilter();
        }
        if (child.searchView && child.searchView.createFilter) {
          return child.searchView.createFilter();
        }
      }

      return null;
    });

    return (util.compact(filters));
  },

  removeFilter(filterView) {
    if (filterView) {
      this.removeChildView(filterView);
      if (this.children.length === 0) {
        this.addFilter();
      }
      this.showHideAddFilterButton();
    }
  }
});
